/**
 * @desc 校验新登录密码的格式
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 新登录密码 */
  newPassword: string;
}

export function request(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.get({
    url: '/web/user/checkNewPwd',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.get({
    url: '/mock/web/user/checkNewPwd',

    params,
  });
}
